// extracted by mini-css-extract-plugin
export default {"zoom":"Zla-z","zoomContent":"_la-z"};